// src/pages/Help.js

import React from "react";

export default function Help() {
  return (
    <div>
      <h1>Help</h1>
      <p>

StaffIQ is een slim en praktisch CRM-systeem voor het MKB.<br />
Het systeem is ontwikkeld voor handels- en productiebedrijven, personele dienstverlening en projectmatig werkende bedrijven.<br />
Je werkt op eenvoudige wijze met geïntegreerde AI en directe koppelingen, die dagelijkse handelingen sneller en eenvoudiger maken. 
Het systeem bestaat op dit moment uit onderdelen voor:
      <ul>
        <li>Organisaties / Relaties</li>
        <li>Contactpersonen</li>
        <li>Notities / Taken</li>
        <li>Documentbeheer</li>
        <li>Projectbeheer</li>
        <li>Offertes / Opdrachten / Projectregistratie</li>
        <li>Facturering</li>
<br />
        <li>Personeel</li>
        <li>Matching Organisaties</li>
        <li>Matching Personeel</li>
        <li>Aanvragen</li>
        <li>Vacatures</li>
        <li>Plaatsingen</li>

      </ul>
Wekelijks wordt er nieuwe functionatiteit toegevoegd.<br />
<br />
De knop Spreek kan gebruikt worden, wanneer de browser spreekondersteuning heeft.<br />
Voor iedere rubriek dient Spreek geactiveerd te worden.<br />
<br />
Spraakcommando’s:
      <ul>
        <li>volgende</li>
        <li>vorige / terug</li>
        <li>nieuw</li>
        <li>vernieuw</li>
        <li>item / selecteer / rechts</li>
        <li>lijst / links</li>
        <li>leeg</li>
        <li>punt</li>
        <li>klaar</li>
        <li>open</li>
        <li>stop / klaar</li>
        <li>ja/nee / aan/uit</li>
      </ul>

De structuur is eenvoudig van opzet en alle functies hebben dezelfde indeling.<br />
De layout wordt automatisch aangepast als je op je smartphone of op een tablet wilt werken.<br />
<br />
Op de laptop / PC is de standaard indeling als volgt:<br />
Links het Menu.<br />
Midden het overzicht van de gegevens met sorteer- en filteropties.<br />
Na het klikken op een regel wordt het invoerblok ingevuld en kun je wijzigingen doorvoeren.<br />
Als je klikt op een telefoonnummer, dan kun je dit nummer bellen.<br />
Als je klikt op een mobiel nummer, dan kun je bellen, WhatsAppen of een SMS sturen.<br />
Als je klikt op een e-mail adres, dan wordt het e-mail programma geopend.<br />
Rechts het invoerblok met onder elkaar de verschillende items.<br />
Indien er meer ruimte nodig is voor de invoer of raadpleging van gegevens, dan wordt er automatisch een popup getoond.<br />
De namen van de rubrieken spreken voor zich.<br />
<br />
Op de smartphone staan het overzicht en het invoerblok onder elkaar.<br />
Het menu roep je op door op de 3 streepjes links boven te klikken.<br />
<br />
Het menu bestaat op dit moment uit 2 delen.<br />
CRM met een pijltje naar rechts.<br />
Als je op dit pijltje klikt, dan kom je terecht in het menu HRM.<br />
Met het pijltje naar links kun je weer terug naar het CRM gedeelte.<br />
<br />
Het CRM deel zal vooral worden gebruikt door het MKB.<br />
Hier kun je de relaties bijhouden, notities of taken maken, offertes / opdrachten vastleggen en factureren.<br />
Je kunt met artikelen, diensten of met projecten werken.<br />
<br />
Het HRM deel zal vooral worden gebruikt door de personele dienstverlening.<br />
Hier kun je de personeel bijhouden, aanvragen matchen, en plaatsingen vastleggen.<br />
Dit deel heeft zeer uitgebreide functionaliteit voor matching.<br />
<br />
Het systeem vult zoveel mogelijk gegevens in de programma's automatisch in.<br />
Die gegevens kun je dan wel altijd weer overschrijven.<br />
De gegevens uit de organisatie worden zoveel mogelijk als basis gebruikt voor offertes, opdrachten en facturen.<br />
<br />
Notities en Taken vind je binnen dezelfde functie.<br />
Het belangrijkste verschil is, dat het systeem je herinnert aan openstaande taken.<br />
Je krijgt een melding van je openstaande taken als je inlogt in het systeem.<br />
En, indien gewenst, dan kun je automatisch een herinnering per e-mail naar jezelf laten sturen.<br />
Dit wordt iedere dag om 10.00 uur herhaald, tot de taak de status "Klaar" krijgt.<br />
<br />
Alle documenten kunnen worden opgeslagen en opgehaald worden vanaf een vaste map per klant of personeelslid.<br />
Deze mappen worden door het systeem automatisch aangemaakt op een plaats die is vastgelegd bij de instellingen.<br />
Dit kan lokaal zijn, of in de cloud, afhankelijk van de gemaakte keuze.<br />
Alleen de administrator kan de instellingen aanpassen.<br />
Ook de met StaffIQ gemaakte documenten, zoals offertes, opdrachten, facturen en personeelsdocumenten worden automatisch in de klantenmap geplaatst.<br />
<br />
Projecten en deelprojecten kunnen in niveaus worden vastgelegd.<br />
Je kunt hierbij zelf een nummersysteem opzetten, bijvoorbeeld 01 / 01.01 / 01.02.<br />
Hierbij kun je ook kiezen voor 3 voorloopnullen als er meer dan 100 lagen zijn.<br />
Er kan indien gewenst een prijs voor het deelproject worden ingevoerd.<br />
Maar je kunt er natuurlijk ook voor kiezen om een prijs per kg of per m2 in te voeren.<br />
Dit kan dan het beste in de tekst worden vermeld.<br />
Er is tekst die op de offerte/opdracht/factuur wordt vermeld, maar je kunt ook tekst toevoegen voor intern gebruik.<br />
Een project of deelproject kan worden gekopieerd en dan aangepast. Op deze manier kun je snel nieuwe projecten definiëren<br />
<br />

Je kunt een nieuwe offerte aanpassen en uitprinten, en ook automatisch per e-mail versturen naar de klant.<br />
Als de offerte goedgekeurd is, dan wordt hij omgezet naar een opdracht.<br />
Deze opdracht kan worden geprint, of per e-mail als bevestiging naar de klant worden gestuurd.<br />
En vervolgens resulteert een goedgekeurde opdracht in een (concept)factuur.<br />
<br />
In de functie facturen kan de concept factuur worden gecontroleerd en vervolgens definitief worden gemaakt,<br />
Daarna krijgt hij een factuurnummer en kan worden geprint of per e-mail naar de klant worden gestuurd.<br />
De (deel)betalingen kunnen in het Facturen programma worden bijgehouden.<br />
<br />

Het programma Personeel kent uitgebreide functonaliteit inclusief flexibele matching opties.<br />
De personeelskaart kan worden geprint in een uitgebreide vorm of in een beknopte versie voor extern gebruik.<br />
Ook kun je de personeelskaart als document opslaan.<br />
<br />

Aanvragen van klanten kunnen compleet worden vastgelegd.<br />
Vanuit de aanvraag kun je direct de geschikte kandidaat matchen.<br />
Vervolgens wordt eventueel direct de plaatsing als concept aangemaakt.<br />
<br />

Hieronder het volledige proces:<br />
<br />
1. Aanvraag aanmaken<br />
In Aanvragen leg je de klantvraag vast:<br />
relatie<br />
contactpersoon<br />
functie<br />
aantal personen<br />
startdatum<br />
uren per week<br />
regio / plaats / locatie<br />
tarief / factor / reiskosten<br />
eisen zoals rijbewijs, vervoer, ervaring, certificaten<br />
interne en externe opmerkingen<br />
Status van de aanvraag is bijvoorbeeld: Open<br />
De aanvraag is dan nog geen kandidaat en nog geen plaatsing. Het is alleen de klantvraag.<br />
<br />
2. Vanuit Aanvraag naar Matching Personeel<br />
Vanuit de aanvraag klik je op Match Personeel.<br />
Matching Personeel krijgt dan criteria mee uit de aanvraag:<br />
functie<br />
regio<br />
plaats<br />
rijbewijs<br />
eigen vervoer<br />
uurloon max<br />
ZZP<br />
matchingtekst / profiel<br />
Daarna toont Matching Personeel alle kandidaten, gesorteerd op matchpercentage.<br />
Belangrijk: dit is een selectiehulpmiddel, geen formele processtap.<br />
<br />
3. Kandidaat kiezen<br />
In Matching Personeel kies je een kandidaat.<br />
Daarna klik je op Plaatsing maken<br />
Dan ontstaat de concrete combinatie:<br />
Deze kandidaat hoort bij deze aanvraag/klant.<br />
<br />
4. Conceptplaatsing aanmaken<br />
In Plaatsingen wordt nu direct een plaatsing aangemaakt met status: Concept<br />
Dit is logisch. De plaatsing bestaat echt, maar is nog niet definitief.<br />
In deze fase controleer of wijzig je:<br />
plaatsingsdatum<br />
plaatsingsnummer<br />
aanvraag<br />
relatie<br />
contactpersoon<br />
personeelslid<br />
functie<br />
startdatum / einddatum<br />
uren per week<br />
tarief / uurloon / factor / reiskosten<br />
status kandidaat<br />
status klant<br />
opmerkingen<br />
Dit is vergelijkbaar met een conceptofferte.<br />
<br />
5. Voorstellen<br />
Met Voorstellen geef je aan:<br />
Deze kandidaat is voorgesteld aan de klant, en/of de plaatsing is in behandeling genomen.<br />
Status wordt dan: Voorgesteld<br />
Kandidaatstatus bijvoorbeeld: Voorgesteld<br />
Klantstatus bijvoorbeeld: In behandeling<br />
Hier is de plaatsing nog niet definitief. Het is vergelijkbaar met: offerte is verzonden, maar nog niet akkoord.<br />
<br />
6. Kandidaat akkoord<br />
De kandidaat wil/kan deze plaatsing doen.<br />
Dan wordt: kandidaat bevestigd = ja<br />
status kandidaat = akkoord<br />
Dit betekent nog niet dat de klant akkoord is.<br />
<br />
7. Klant akkoord<br />
Met Klant akkoord leg je vast:<br />
De klant accepteert deze kandidaat.<br />
Dan wordt: klant bevestigd = ja<br />
status klant = akkoord<br />
Nu zijn beide partijen akkoord.<br />
<br />
8. Bevestigen<br />
Met Bevestigen wordt de plaatsing formeel bevestigd.<br />
Status wordt: Bevestigd<br />
Dit is de HRM-variant van:<br />
Offerte goedgekeurd → Opdracht<br />
Vanaf dit moment moet de plaatsing eigenlijk als officiële afspraak worden gezien.<br />
Hier horen de bevestigingsdocumenten bij:<br />
Plaatsingsbevestiging klant<br />
Plaatsingsbevestiging kandidaat<br />
En eventueel:<br />
mail klant<br />
mail kandidaat<br />
Dus eigenlijk zou Bevestigen straks automatisch of semi-automatisch moeten leiden tot:<br />
plaatsing status = Bevestigd<br />
document klant klaarzetten / opslaan<br />
document kandidaat klaarzetten / opslaan<br />
mogelijkheid om beide te mailen<br />
<br />
9. Starten<br />
Met Starten geef je aan:<br />
De kandidaat is daadwerkelijk begonnen.<br />
Status wordt: Gestart<br />
Dit is belangrijk voor de volgende modules:<br />
planning<br />
bezetting<br />
urenregistratie<br />
facturering<br />
managementinformatie<br />
Een bevestigde plaatsing is administratief rond.<br />
Een gestarte plaatsing is operationeel begonnen.<br />
<br />
10. Stoppen<br />
Met Stoppen beëindig je de plaatsing.<br />
Status wordt: Gestopt<br />
Als einddatum leeg is, mag het systeem die vullen met vandaag.<br />
Dit wordt later belangrijk voor:<br />
laatste uren<br />
eindfactuur<br />
kandidaat weer beschikbaar maken<br />
evaluatie<br />
managementrapportage<br />
<br />
11. Annuleren<br />
Annuleren gebruik je als de plaatsing niet doorgaat<br />
Bijvoorbeeld:<br />
kandidaat haakt af<br />
klant trekt aanvraag in<br />
startdatum vervalt<br />
verkeerde plaatsing aangemaakt<br />
Status wordt: Geannuleerd<br />

<br /><br />
De volgende onderdelen zijn in ontwikkeling en wekelijks worden nieuwe programma's aan StaffIQ toegevoegd.
      <ul>
        <li>Urenregistratie</li>
        <li>Planning</li>
        <li>Bezettingsoverzicht</li>
        <li>Materiaal / Producten / Stuklijst</li>
        <li>Inkoop</li>
        <li>Magazijn / Voorraad</li>
        <li>Kostprijsberekening / Voorcalculatie</li>
        <li>Pakbon</li>
        <li>Materiaal registratie</li>
        <li>Bezetting en Logistiek</li>
        <li>Nacalculatie</li>
        <li>Management informatie</li>
        <li>Dashboard</li>
      </ul>
<br /><br />

Wij staan open voor goede suggesties, en blijven nieuwe onderdelen voor StaffIQ ontwikkelen.
Graag ontvangen wij uw ideeën per e-mail info@staffiq.nl of via onze website www.staffiq.nl.

      </p>
    </div>
  );
}